import { fetchWithSupabaseAuth } from "./supabaseClient.js";

async function request(path, payload, { blob = false } = {}) {
  const response = await fetchWithSupabaseAuth(`/api/report-emails${path}`, payload === undefined ? undefined : {
    method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload),
  });
  if (response.ok && blob) return response;
  const body = await response.json().catch(() => null);
  if (!response.ok) {
    const detail = body?.detail;
    throw new Error(typeof detail === "string" ? detail : detail?.message || (Array.isArray(detail) ? detail[0]?.msg : null) || "Impossible de traiter le courriel.");
  }
  return body;
}

export const fetchReportEmailCatalog = () => request("/catalog");
export const fetchReportEmailTargets = () => request("/targets");
export const previewReportEmail = (action) => request("/preview", { action });
export const previewReportEmailDashboardPdf = (action) => request("/preview-dashboard-pdf", { action }, { blob: true });
export const sendReportEmail = (action, requestId) => request("/send", { action, request_id: requestId });
export const fetchReportEmailRun = (runId) => request(`/runs/${encodeURIComponent(runId)}`);
export async function downloadReportEmailPreview(action, index) {
  const response = await request(`/preview-document?index=${index}`, { action }, { blob: true });
  const url = URL.createObjectURL(await response.blob());
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = /filename="([^"]+)"/.exec(response.headers.get("Content-Disposition") || "")?.[1] || "rapport.pdf";
  anchor.click();
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

export async function downloadReportEmailDashboardPdf(action) {
  const response = await previewReportEmailDashboardPdf(action);
  const url = URL.createObjectURL(await response.blob());
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = /filename="([^"]+)"/.exec(response.headers.get("Content-Disposition") || "")?.[1] || "graphiques-tableau-de-bord.pdf";
  anchor.click();
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
